import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { ObservableMedia } from '@angular/flex-layout';

import { NavigationNode, Utils, RequestGeneral } from '@app/core';

import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  title$ = this.store.select(fromStore.selectPageTitle);
  user$ = this.store.select(fromStore.selectLoggedInUser);
  requests$ = this.store.select(fromStore.selectAllRequests)

  sideNavNodes$ = this.store.select(fromStore.selectLoggedInUser)
    .switchMap(user => {
      return this.store.select(fromStore.selectNavigationNodes)
        .map(nodes => {
          return this.filterNodes([...nodes], (user && user.permissions), (user && user.roles))
        });
    });

  constructor(public media: ObservableMedia, private store: Store<fromStore.State>) {
  }


  filterNodes(nodes: NavigationNode[], userPermissions: Array<string>, userRoles: Array<string>): NavigationNode[] {
    if (nodes == null) return;
    var len = nodes.length;

    while (len--) {
      if (!(Utils.hasOneOfOrNoRestriction(userPermissions, nodes[len].permissions)
        && Utils.hasOneOfOrNoRestriction(userRoles, nodes[len].roles))) {
        nodes.splice(len, 1);
      } else {
        this.filterNodes(nodes[len].children, userPermissions, userRoles);
      }
    }
    return nodes;
  }


  ngOnInit() {
    this.store.dispatch(new fromStore.NavigationAction.Load())
    this.store.dispatch(new fromStore.DashboardActions.LoadAllRequests());
  }

  ngOnDestroy(): void {
  }

  onLogout() {
    this.store.dispatch(new fromStore.Logout());
  }

  onProfile(id: number) {
    this.store.dispatch(new fromStore.Go({ path: [`/profile`] }))
  }

  onSelectRequest(request: RequestGeneral) {

    switch (request.requestTypeName) {
      case 'F&M General Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/facility-and-maintenance/general-request', request.requestId],
        })
        );
        break;
      case 'F&M Special Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/facility-and-maintenance/special-request', request.requestId],
        })
        );
        break;
      case 'Hazard Delivery Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/facility-and-maintenance/delivery-request', request.requestId],
        })
        );
        break;
      case 'General Delivery Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/facility-and-maintenance/delivery-request', request.requestId],
        })
        );
        break;
      case 'Meeting Room Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/venues/requests', request.requestId],
        })
        );
        break;
      case 'Access Card Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/access-card/requests', request.requestId],
        })
        );
        break;
      case 'Event Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/event/event-list', request.requestId, 0],
        })
        );
        break;
      case 'Access Card Cancellation Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/access-card/cancellation-requests', request.requestId],
        })
        );
        break;
      case 'Register Hazard Material Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/facility-and-maintenance/register-hazard-material', request.requestId],
        })
        );
        break;
      case 'Manual Charges Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/invoice', request.requestId],
        })
        );
        break;
      case 'Supplier Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/supplier', request.requestId],
        })
        );
        break;
      case 'Announcement Request':
        this.store.dispatch(new fromStore.Go({
          path: ['/announcement', request.requestId],
        })
        );
        break;

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/containers/home/home.component.ts